module.exports = __webpack_public_path__ + "static/media/followers.675e233c.png";